module.exports = __webpack_public_path__ + "static/media/9.728ac670.gif";